<div class="button" *ngIf="!isLoading">
  <button class="btn" (click)="openMarketplace()">
    Перейти в {{ isIOS ? 'App Store' : 'Google Play' }}
  </button>
  <button class="btn" routerLink="/">Перейти на elegro</button>
</div>
<div *ngIf="isLoading" class="loader"></div>
